"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MangopayInformation = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const type_graphql_1 = require("type-graphql");
const uuid_1 = require("uuid");
const transformCurrencyToCurrencyISO_1 = require("../transformers/transformCurrencyToCurrencyISO");
const transformToDate_1 = require("../transformers/transformToDate");
let MangopayInformation = class MangopayInformation {
    _id = (0, uuid_1.v4)();
    mangopayId;
    wallets = [];
    bankAccounts = [];
    recipients = [];
    approvedAt;
    personType;
    identityProofDocumentId;
    articlesOfAssociationDocumentId;
    registrationProofDocumentId;
    shareholderDeclarationDocumentId;
    disabledAt;
    billingInformationId;
    KYCLevel;
    userStatus;
    scaActivatedAt;
    scaStartedAt;
    getWallet(currency = legacy_enums_1.Currency.Euro) {
        return this.wallets.find((w) => w.currency === currency);
    }
    getWalletOrFail(currency = legacy_enums_1.Currency.Euro) {
        const wallet = this.getWallet(currency);
        if (!wallet) {
            throw Error(`Wallet not found for the given currency ${(0, transformCurrencyToCurrencyISO_1.transformCurrencyToCurrencyISO)(currency)}`);
        }
        return wallet;
    }
    getRecipient(currency = legacy_enums_1.Currency.Euro) {
        return this.recipients?.find((r) => r.currency === currency);
    }
    getRecipientOrFail(currency = legacy_enums_1.Currency.Euro) {
        const recipient = this.getRecipient(currency);
        if (!recipient) {
            throw Error(`Recipient not found for the given currency ${(0, transformCurrencyToCurrencyISO_1.transformCurrencyToCurrencyISO)(currency)}`);
        }
        return recipient;
    }
    upsertRecipient(recipient) {
        const existingIndex = this.recipients.findIndex((r) => r.currency === recipient.currency);
        if (existingIndex > -1) {
            this.recipients.splice(existingIndex, 1, recipient);
        }
        else {
            this.recipients.push(recipient);
        }
    }
    isKYCValid() {
        return this.KYCLevel === legacy_enums_1.KYCLevel.Regular;
    }
};
exports.MangopayInformation = MangopayInformation;
__decorate([
    (0, class_validator_1.IsUUID)("4"),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], MangopayInformation.prototype, "_id", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], MangopayInformation.prototype, "mangopayId", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], MangopayInformation.prototype, "wallets", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)()
    // @deprecated use recipients instead
    ,
    __metadata("design:type", Array)
], MangopayInformation.prototype, "bankAccounts", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], MangopayInformation.prototype, "recipients", void 0);
__decorate([
    transformToDate_1.TransformToDate,
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Date)
], MangopayInformation.prototype, "approvedAt", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], MangopayInformation.prototype, "personType", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], MangopayInformation.prototype, "identityProofDocumentId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], MangopayInformation.prototype, "articlesOfAssociationDocumentId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], MangopayInformation.prototype, "registrationProofDocumentId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], MangopayInformation.prototype, "shareholderDeclarationDocumentId", void 0);
__decorate([
    transformToDate_1.TransformToDate,
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Date)
], MangopayInformation.prototype, "disabledAt", void 0);
__decorate([
    (0, class_validator_1.IsUUID)("4"),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], MangopayInformation.prototype, "billingInformationId", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], MangopayInformation.prototype, "KYCLevel", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], MangopayInformation.prototype, "userStatus", void 0);
__decorate([
    transformToDate_1.TransformToDate,
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Date)
], MangopayInformation.prototype, "scaActivatedAt", void 0);
__decorate([
    transformToDate_1.TransformToDate,
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Date)
], MangopayInformation.prototype, "scaStartedAt", void 0);
exports.MangopayInformation = MangopayInformation = __decorate([
    (0, type_graphql_1.ObjectType)("MangopayInformation"),
    (0, class_transformer_1.Exclude)()
], MangopayInformation);
//# sourceMappingURL=MangopayInformation.js.map